import { Breadcrumb, Card, Col, EventHandler, InputField, Label, OutlineButton, PrimaryButton, ReactSelectBox, Row, SwitchToggle } from "client/CommonComponents";
import CancelConfirmationPopup from "client/CommonComponents/DialogBox/CancelConfirmationPopup";
import './CreateJobTitle.scss';
import permissions, { isAuthorized } from "client/utils/Permissions";


const CreateJobTitle = (props?: any) => {

    const {
        breadcrumlist,
        handleClickBack,
        popupContent,
        hideDialog,
        assignmentGroupList,
        onClickAdd,
        isActive,
        isLogoed,
        onIsActiveChange,
        onLogoedChange,
        jobTitle,
        assignmentGroup,
        onChangeAssignmentGroup,
        onChangesJobTitle,
        error,
        id
    } = props;

    return (
        <>
            <div className='breadCrumbBlock'>
                <EventHandler onEvent={(e: any) => handleClickBack(e)} data-attribute="CreateJobTitle_Default_EventHandler">
                    <div className='backButton mb-sm-2 mb-3'>
                        <span className="fa fa-chevron-left"></span>
                        Back
                    </div>
                </EventHandler>
                <div className='breadcrumbList'>
                    <Breadcrumb items={breadcrumlist} maxDisplayedItems="5"  data-attribute="CreateJobTitle_Default_Breadcrumb" />
                </div>
            </div>
            <Card data-attribute="CreateJobTitle_Default_Card">
                <div className='create-new-order-container admin-tab'>
                    <div className='grid-block pt-3 pb-0'>
                        <div className="row">
                            <div className='penalityHeader'>
                                <p className='headingText pull-left'> {id ? "Edit Job Title" : 'Add new Job Title'}</p>
                            </div>
                        </div>
                        <div className='bottom-section'>
                            <div className="addjob_topsection mt-3">
                                <Row>
                                    <Col xs={6} sm={6} className='mb-3'>
                                        <Label required data-attribute="CreateJobTitle_Default_Label">Job Title</Label>
                                        <InputField
                                            placeholder="Enter Job Title"
                                            name="model"
                                            value={jobTitle}
                                            className={error?.jobTitleError?.length ? 'controlValidation' : ""}
                                            onChange={(e: any) => onChangesJobTitle(e)}
                                         data-attribute="CreateJobTitle_model_Input" />
                                        {error?.jobTitleError?.length ? <p className='validMessage create_new_job'>{error?.jobTitleError}</p> : null}
                                    </Col>
                                    <Col xs={6} sm={6} className=' toggle_btns'>
                                        <Label required data-attribute="CreateJobTitle_Default_Label_2">Logoed</Label>
                                        <SwitchToggle
                                            checked={!!isLogoed}
                                            onChange={(e?: any, item?: any) => onLogoedChange(e, item)}
                                         data-attribute="CreateJobTitle_Default_SwitchToggle" />
                                    </Col>
                                </Row>
                            </div>
                            <div className="mt-3">
                                <Row>
                                    <Col xs={6} sm={6} className='mb-3 '>

                                        <Label required data-attribute="CreateJobTitle_Default_Label_3">Assignment Group</Label>
                                        <ReactSelectBox
                                            options={assignmentGroupList}
                                            isSearchable={true}
                                            value={assignmentGroup}
                                            className={error?.assignmentGroupError?.length ? 'controlValidation' : ""}
                                            onChange={(item: any) => onChangeAssignmentGroup(item)}
                                            placeholder="Select Assignment Group"
                                         data-attribute="CreateJobTitle_Default_SearchSelectBox" />
                                        {error?.assignmentGroupError?.length ? <p className='validMessage create_new_job'>{error?.assignmentGroupError}</p> : null}
                                    </Col>
                                    <Col xs={6} sm={6} className='toggle_btns'>
                                        <Label required data-attribute="CreateJobTitle_Default_Label_4">Status</Label>
                                            <div className="toggle_btns_style">
                                                <SwitchToggle
                                                    className=""
                                                    checked={!!isActive}
                                                    onChange={(e?: any, item?: any) => onIsActiveChange(e, item)}
                                                 data-attribute="CreateJobTitle_Default_SwitchToggle_2" />
                                                <p className="status_info">{!!isActive ? 'Active' : 'InActive'}</p>
                                            </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="mt-2 mt-sm-3">
                                <PrimaryButton
                                    text={id ? 'Save' : 'Add'}
                                    className='pull-right add-vehicle-level'
                                    onClick={(e: any) => onClickAdd(false)}
                                    disabled={!isAuthorized(permissions?.Create_Edit_JobTitle)}
                                 data-attribute="CreateJobTitle_Default_Button" />
                                <OutlineButton
                                    text='Cancel'
                                    className='pull-right add-vehicle-level ms-3'
                                    onClick={(e: any) => handleClickBack(e)}
                                 data-attribute="CreateJobTitle_Default_Button_2" />
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
            <CancelConfirmationPopup
                hideDialog={!popupContent.isDialogVisible}
                onDismiss={() => popupContent.popupOutlinebtnOnclick()}
                Popupcontent={popupContent}
                popupOutlinebtnOnclick={() => popupContent.popupOutlinebtnOnclick()}
                popupPrimarybtnOnclick={() => popupContent.popupPrimarybtnOnclick()}
            />
        </>
    )
}

export default CreateJobTitle;